import axios, { AxiosRequestConfig, AxiosInstance } from 'axios';
import ENV from '../environment';

export class AxiosService {

    private axiosInstance: AxiosInstance;

    constructor(host: string) {
        this.axiosInstance = axios.create(
            {
                baseURL: host,
                timeout: 10000,
            });
        this.setInterceptor();
    }

    public get(url: string, params?) {
        return this.axiosInstance.get(url, { params });
    }

    public post(url: string, data) {

        let config = {};

        if (data) {
            config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };
        }
        return this.axiosInstance.post(url, data, config);
    }

    public put(url: string, data) {
        return this.axiosInstance.put(url, data);
    }

    public delete(url: string) {
        return this.axiosInstance.delete(url);
    }

    get $http() {
        return this.axiosInstance;
    }

    public setInterceptor() {
        this.axiosInstance.interceptors.request.use(
            (config: AxiosRequestConfig) => {
                config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
                return config;
            },
            (error: Error) => Promise.reject(error));
    }

}

export const axiosService = new AxiosService(ENV.APP_API_HOST);
